export const IMPERSONATION_USER_TOKEN_LOGIN = "AUTH@IMPERSONATION_USER_TOKEN_LOGIN";
export const IMPERSONATION_USER_TOKEN_LOGIN_INIT = "AUTH@IMPERSONATION_USER_TOKEN_LOGIN_INIT";
export const IMPERSONATION_USER_TOKEN_LOGIN_SUCCESS = "AUTH@IMPERSONATION_USER_TOKEN_LOGIN_SUCCESS";
export const IMPERSONATION_USER_TOKEN_LOGIN_FAILED = "AUTH@IMPERSONATION_USER_TOKEN_LOGIN_FAILED";
